<template>
  <div class="app" style="cursor: pointer;">
    <i class="iconfont iconshouji" style='margin-right: 6px; '></i>
    APP
    <div class="code" style="cursor: default">
<!--      <div class="title">{{useByPhone === 'app' ? '扫码下载APP 同步编辑' : '扫码关注 微信同步'}}</div>-->
      <div class="title">{{useByPhone === 'app' ? '超级简历 APP' : '扫码关注 微信同步'}}</div>
      <div class="subtitle" v-show="useByPhone === 'app'">
        <span>扫码下载APP，随时随地改简历</span>
      </div>
      <img style="position: relative; left: 1px" :src="useByPhone === 'app' ? (codeImage || 'https://files.wondercv.com/download-code/nav-bar-vue.png') : 'https://files.wondercv.com/wechat-app1.png'" alt="qrcode">
<!--      <div class="btn">-->
<!--        <button :class="[useByPhone === 'app' ? 'action' : '']" @click="useByPhone = 'app'">iOS/安卓App</button>-->
<!--        <button :class="[useByPhone === 'wx' ? 'action' : '']" @click="useByPhone = 'wx'">微信小程序</button>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
  export default {
  	props: {
  		codeImage: {
  			type: String,
        default: ''
      }
    },
    data () {
      return {
        useByPhone: 'app',
        usePhone: false,
      }
    },
    methods: {
      changeUsePhone (type) {
        this.useByPhone = type
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import '~/assets/css/variable';
  .app {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #797B7E;
    &>img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      margin-top: 2px;
      margin-right: -1px;
      margin-left: 1px;
    }
    &:hover {
      color: #fff;
      .code {
        display: flex;
      }
    }
    .code {
      display: none;
      width: 240px;
      height: 270px;
      background: #fff;
      //border: 1px solid #DEDFE1;
      position: absolute;
      top: 56px;
      //bottom: -258px;
      left: 50%;
      transform: translateX(-50%);
      color: #404040;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(128, 128, 128, 0.16);
      flex-direction: column;
      align-items: center;
      .title {
        font-size: 16px;
        margin-top: 24px;
        margin-bottom: 8px;
        font-weight: 500;
        line-height: 16px;
      }
      .subtitle {
        font-size: 12px;
        font-weight: 400;
        color: #9c9c9c;
        margin-bottom: 12px;
        line-height: 12px;
      }
      img {
        width: 160px;
        height: 160px;
        margin: 4px auto 0;
      }
      .btn {
        button {
          display: block;
          background: #fff;
          margin: auto;
          width: 160px;
          height: 30px;
          border: 1px solid #ff4f4c;
          text-align: center;
          line-height: 27px;
          border-radius: 2px;
          color: #ff4f4c;
          margin: auto;
          margin-top: 12px;
          &.action, &:hover {
            color: #fff;
            background: #ff4f4c;
          }
        }
      }
    }
  }
</style>
